import { dependencies } from '@pn/core/dependencies';
import {
  getBeforeItemLayerId,
  type WorkspaceItem,
} from '@pn/core/domain/workspace';
import { getMapboxAnnotationsLayers } from '@pn/services/map/mapbox/methods/addAnnotationLayer';

/**
 * Moves the item's layers below the nearest item above it that is actually
 * on the map. Visible items can be missing from the map (e.g. still loading,
 * failed or empty); such items will position themselves on visualization.
 *
 * @param itemsAbove Items above `item` in the workspace, nearest first.
 */
export function moveWorkspaceItem(
  item: WorkspaceItem,
  itemsAbove: WorkspaceItem[]
): void {
  const { map } = dependencies;

  if (item.itemType === 'drawing') return;

  const beforeLayerId = itemsAbove
    .filter((itemAbove) => itemAbove.isVisible)
    .map((itemAbove) => getBeforeItemLayerId(itemAbove))
    .find((layerId) => map.hasLayer(layerId));

  if (item.itemType === 'annotation') {
    getMapboxAnnotationsLayers(`annotation-${item.id}`).forEach((layer) => {
      if (!map.hasLayer(layer.id)) {
        console.error(`Failed to move: layer ${layer.id} does not exist`);
        return;
      }

      map.moveLayer(layer.id, beforeLayerId);
    });
  }

  item.map.layers.forEach((layer) => {
    /* The item itself may not be on the map yet if it's still loading. */
    if (map.hasLayer(layer.id)) map.moveDataLayer(layer, beforeLayerId);
  });
}
